import React from "react";
import {
    ButtonIconCancel,
    ButtonIconSave, convertInputFormToObject,
    NumberField,
    checkAndSetError,
    clearInputFormErrorFields,
    inputFormIsValid,
    SelectField, TextArea,
    TextField,
    useInputForm
} from "../../../../../Components/Inputs";
import {loanLibraryInventoryItemModel} from "./loanLibraryInventoryItemFactory";
import {INVENTORY_STATUS_LIST} from "../../loanLibraryConstants";
import {gridConstants} from "../../../../../Components/Grid";
import {getLoanLibraryInventoryItemId} from "./loanLibraryInventoryUtility";
import {error as notifyError} from "../../../../../Components/Notifications/NotifyUser/notifyUserUtility";


interface LoanLibraryInventoryEditRowProps {
    canManageCatalog: boolean;
    handleSaveInventoryItem: (data: Record<string, unknown>, index: number) => void;
    handleCancelInventoryItem: () => void;
    index: number;
    loanLibraryInventoryItem: Record<string, any>;
}

export const LoanLibraryInventoryEditRow = ({
                                            canManageCatalog,
                                            handleSaveInventoryItem,
                                            handleCancelInventoryItem,
                                            index,
                                            loanLibraryInventoryItem,
                                        }: LoanLibraryInventoryEditRowProps) => {

    const inventoryItemForm = useInputForm(loanLibraryInventoryItemModel(loanLibraryInventoryItem));

    const handleClickSaveInventoryItem = () => {
        clearInputFormErrorFields(inventoryItemForm);
        checkAndSetError([inventoryItemForm.shelfLocation]);

        if (!inputFormIsValid(inventoryItemForm)) {
            notifyError("Shelf Location is required.");
            return;
        }        
        const loanLibraryInventoryItem = convertInputFormToObject(inventoryItemForm);

        handleSaveInventoryItem(loanLibraryInventoryItem, index);
    };

    const handleClickCancelInventoryItem = () => {
        handleCancelInventoryItem();
    };

    const loanLibraryInventoryItemId = getLoanLibraryInventoryItemId(loanLibraryInventoryItem, index);

    return <>
        <tr id={loanLibraryInventoryItemId} data-testid={loanLibraryInventoryItemId}>
            <td>{loanLibraryInventoryItem.shortId || ''}</td>
            <td>
                <NumberField
                    {...inventoryItemForm.copyNumber}
                    disabled={!canManageCatalog}
                    isPositiveNumberOnly
                    isWholeNumberOnly
                    labelClass={ "show-for-sr"}
                    medium_columns={gridConstants.column.THREE}
                />
            </td>
            <td>
                <TextField
                    {...inventoryItemForm.shelfLocation}
                    disabled={!canManageCatalog}
                    labelClass={ "show-for-sr"}
                    medium_columns={gridConstants.column.THREE}
                />
            </td>
            <td>
                <TextField
                    {...inventoryItemForm.serialNumber}
                    disabled={!canManageCatalog}
                    labelClass={ "show-for-sr"}
                    medium_columns={gridConstants.column.THREE}
                />
            </td>
            <td>
                <TextField
                    {...inventoryItemForm.assetNumber}
                    disabled={!canManageCatalog}
                    labelClass={ "show-for-sr"}
                    medium_columns={gridConstants.column.THREE}
                />
            </td>
            <td>
                <SelectField
                    {...inventoryItemForm.status}
                    disabled={!canManageCatalog}
                    hideLabel
                    includeDefaultOption
                    medium_columns={gridConstants.column.THREE}
                    options={INVENTORY_STATUS_LIST}
                />
            </td>
            <td>
                <TextArea
                    {...inventoryItemForm.notes}
                    disabled={!canManageCatalog}
                    label={`Notes for item ${index + 1}`}
                    medium_columns={gridConstants.column.THREE}
                />
            </td>
            <td>
                <ButtonIconSave
                    inputDescription={`save changes for copy ${index + 1}`}
                    onClick={() => handleClickSaveInventoryItem()}
                />
                <ButtonIconCancel
                    inputDescription={`cancel editing for copy ${index + 1}`}
                    onClick={() => handleClickCancelInventoryItem()}
                />
            </td>
        </tr>
    </>;
};

